// Module
var code = "<div class=\"text-center ups-group ng-tns-c0-0 ng-star-inserted\">\r\n    <ng-content></ng-content>\r\n</div>";
// Exports
module.exports = code;